import {Box, Typography} from '@viptech/react-components'
import {useState} from 'react'
import imageErrorIcon from 'src/images/imageErrorIcon.svg'
import whitePlayer from 'src/images/whitePlayer.svg'
import {ImageRenderResponsive} from 'src/pages/alarms/components/styles'
import {SnapshotEvent} from 'src/services/api/endpoints/EventsEndpoint'

type Props = {
  imageToRender: SnapshotEvent
  rowsLenght: number
  imageSelected: () => void
}

function PlayerOnTable({imageToRender, rowsLenght, imageSelected}: Props) {
  const [imgFailed, setImgFailed] = useState(false)
  const [isHoveringPhoto, setIsHoveringPhoto] = useState(false)

  const onMouseEnter = () => setIsHoveringPhoto(true)
  const onMouseLeave = () => setIsHoveringPhoto(false)

  return (
    <Box
      display='flex'
      align='center'
      justifyContent='center'
      direction='column'
      onMouseEnter={onMouseEnter}
      style={{position: 'relative'}}
      onMouseLeave={onMouseLeave}>
      {!imgFailed ? (
        <Box display='flex' align='center' columnGap='10px'>
          <ImageRenderResponsive
            rowsLenght={rowsLenght}
            src={`${process.env.REACT_APP_EVENT_IMAGES_BASE_URL}/${imageToRender.awsKey}`}
            alt=''
            onClick={() => imageSelected()}
            onError={() => setImgFailed(true)}
            style={{boxShadow: isHoveringPhoto ? '0px 4px 8px  #b4b4b4' : ''}}
          />

          {isHoveringPhoto && (
            <Box
              position='absolute'
              left={rowsLenght > 1 ? '40%' : '50%'}
              display='flex'
              align='center'
              justifyContent='center'
              onClick={() => imageSelected()}>
              <img src={whitePlayer} alt='zoom-in' width={20} height={16} style={{cursor: 'pointer'}} />
            </Box>
          )}
        </Box>
      ) : (
        <div>
          <img src={imageErrorIcon} alt='Icone de erro' height={'35px'} width={'50px'} />
          <Typography size='11px' variant='label' textAlign='center' color='#272727'>
            Falha ao carregar imagem
          </Typography>
        </div>
      )}
    </Box>
  )
}

export default PlayerOnTable
